/*eslint eqeqeq: "off"*/
import {
  ADD_MANUFACTURER_DETAILS,
  UPDATE_MANUFACTURER_DETAILS,
  FETCH_MANUFACTURER_DETAILS_LIST,
  EDIT_MANUFACTURER_DETAILS,
  DELETE_MANUFACTURER_DETAILS,
} from "./_manufacturer_Type";
const initialState = {
  _editedDetails: "",
  _action: "View",
  _id: "",
  _msg: "",
  _allDetails: [],
};

const manufacturerReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_MANUFACTURER_DETAILS:
      return {
        ...state,
        _allDetails: [action.payload, ...state._allDetails],
      };
    case EDIT_MANUFACTURER_DETAILS:
      return {
        ...state,
        _editedDetails: action.payload,
        _id: action.id,
      };
    case UPDATE_MANUFACTURER_DETAILS:
      return {
        ...state,
        _editedDetails: "",
        _allDetails: state._allDetails.map((obj) =>
          obj.id == action.payload.id ? action.payload : obj
        ),
      };
    case FETCH_MANUFACTURER_DETAILS_LIST:
      return {
        ...state,
        _editedDetails: "",
        _allDetails: action.listview,
        _msg: "",
      };
    case DELETE_MANUFACTURER_DETAILS:
      return {
        ...state,
        _allDetails: state._allDetails.filter(
          (record) => record.id != action.payload
        ),
      };

    default:
      return state;
  }
};

export default manufacturerReducer;
